module.exports = __webpack_public_path__ + "static/media/loggly-logo-simple.2df084d6.svg";